import type { IconData } from '@stacksjs/iconify-core'

export const signalCellular0: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 456.78V496h480V16h-39.22ZM464 464H54.035L464 54.034Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default signalCellular0
